export const setCookiesAcceptance = (value) => {
  return { type: 'cookieAccepted', payload: value };
};
